define('app/views/tags_view',['app/setup'], function(takhfifan) {
  takhfifan.tagsView = Backbone.View.extend({
    events: {
      'click .tag-page-tabs li': 'tabToggle',
    },
    
    initialize: function() {
      this.loadMap();
      $(window).load(function() {
        $('.tag-page-tabs').removeClass('loading');
      });
    },
    
    loadMap: function() {
      var srcParams = "sensor=false";

      //if (document.domain.match(/\.com$/)) {
        srcParams += "&key=" + $('.deals-map').data('key');
      //}

      var _this = this;
      var src = "async!http://maps.googleapis.com/maps/api/js?" +
                srcParams + "!callback";
      require([src], function() {
        require(['skin/frontend/v3/default/js/tags_map_scripts', 'skin/frontend/v3/default/laser/js/CustomGoogleMapMarker'])
      });
    },
    
    tabToggle: function(evt) {
      var obj = $(evt.target).is('.tag-page-tabs li') ? $(evt.target) : $(evt.target).parents('.tag-page-tabs li');
      var tabTarget = obj.data('target');
      $('.tag-page-tabs li').removeClass('active');
      obj.addClass('active');
      $('.tag-tab-cnt').hide();
      $('.tag-tab-cnt.'+tabTarget).show();
    }
  });
});

